import { takeLatest, put, call } from "redux-saga/effects";
import {
  GetApiKeysAction,
  GetApiKeyByIdAction,
  CreateApiKeyAction,
  UpdateApiKeyAction,
  DeleteApiKeyAction,
  ToggleApiKeyStatusAction,
  GetApiKeyUsageAction,
} from "../../Actions/adminActions";
import {
  setLoading,
  setApiKeys,
  setSelectedApiKey,
  setSelectedApiKeyUsage,
  setError,
  clearError,
  updateApiKey,
  deleteApiKey,
} from "../../Reducers/Admin/adminApiKeysManagementReducer";
import {
  getApiKeys,
  getApiKeyById,
  createApiKey,
  updateApiKey as updateApiKeyService,
  deleteApiKey as deleteApiKeyService,
  toggleApiKeyStatus,
  getApiKeyUsage
} from "../../../services/adminApiKeysManagementService";
import { apiResponse } from "../../../helper/helper";
import { toast } from "react-toastify";
import { toastConfiguration } from "../../../Constant/Data";

// Get API Keys Saga
function* getApiKeysSaga(action) {
  try {
    console.log("getApiKeysSaga admin action", action?.payload);
    yield put(setLoading(true));
    yield put(clearError());
    
    const response = yield call(getApiKeys, action.payload);
    console.log("adminApiKeysManagementService--------", response);
    if (response?.ok) {
      const data = response.data?.data || [];
      const pagination = response.data?.pagination || {};
      // Map API response to match table expectations
      const mappedData = data.map((apiKey) => ({
        id: apiKey._id,
        key: apiKey.key,
        label: apiKey.label,
        isActive: apiKey.isActive,
        count: apiKey.count || 0,
        lastUsed: apiKey.lastUsed,
        userName: apiKey.user?.name,
        userEmail: apiKey.user?.email,
        userId: apiKey.user?._id,
        createdAt: apiKey.createdAt,
        raw: apiKey,
      }));
      
      yield put(setApiKeys({
        apiKeys: mappedData,
        totalApiKeys: pagination.total || mappedData.length,
        totalPages: pagination.pages || 1,
        currentPage: pagination.page || 1
      }));
    } else {
      yield put(setError(response?.data?.message || response?.problem || "Failed to fetch API keys"));
    }
  } catch (error) {
    console.log("error--------", error);
    yield put(setError(error?.message || "Failed to fetch API keys"));
  } finally {
    yield put(setLoading(false));
  }
}

// Get API Key By ID Saga
function* getApiKeyByIdSaga(action) {
  try {
    yield put(setLoading(true));
    yield put(clearError());

    const response = yield call(getApiKeyById, action.payload);

    if (response?.ok) {
      yield put(setSelectedApiKey(response.data));
    } else {
      yield put(setError(response?.data?.message || "Failed to fetch API key details"));
    }
  } catch (error) {
    yield put(setError(error?.message || "Failed to fetch API key details"));
  } finally {
    yield put(setLoading(false));
  }
}

// Create API Key Saga
function* createApiKeySaga(action) {
  try {
    yield put(setLoading(true));
    yield put(clearError());

    const response = yield call(createApiKey, action.payload);
   const {ok,data,originalError}=response||{}
   action?.payload?.action()

    if (response?.ok) {
      // Refresh API keyshos list
      yield toast.success("API Key Generated Successfully",toastConfiguration)
    } else {
      const errorMsg = Boolean(typeof data?.message === "string");
      const message = data?.message || originalError?.message;
      if (errorMsg) toast.error(message, toastConfiguration);
      else toast.error(apiResponse(message), toastConfiguration);
    }
  } catch (error) {
    toast.error("Something Went Wrong ", toastConfiguration);

  } finally {
  }
}

// Update API Key Saga
function* updateApiKeySaga(action) {
  try {
    yield put(setLoading(true));
    yield put(clearError());

    const response = yield call(updateApiKeyService, action.payload);

    if (response?.ok) {
      yield put(updateApiKey(response.data));
    } else {
      yield put(setError(response?.data?.message || "Failed to update API key"));
    }
  } catch (error) {
    yield put(setError(error?.message || "Failed to update API key"));
  } finally {
    yield put(setLoading(false));
  }
}

// Delete API Key Saga
function* deleteApiKeySaga(action) {
  try {
    yield put(setLoading(true));
    yield put(clearError());

    const response = yield call(deleteApiKeyService, action.payload);

    if (response?.ok) {
      yield put(deleteApiKey(action.payload));
    } else {
      yield put(setError(response?.data?.message || "Failed to delete API key"));
    }
  } catch (error) {
    yield put(setError(error?.message || "Failed to delete API key"));
  } finally {
    yield put(setLoading(false));
  }
}

// Toggle API Key Status Saga
function* toggleApiKeyStatusSaga(action) {
  try {
    yield put(setLoading(true));
    yield put(clearError());

    const response = yield call(toggleApiKeyStatus, action.payload);

    if (response?.ok) {
      yield put(updateApiKey({ id: action.payload, isActive: !action.payload.isActive }));
    } else {
      yield put(setError(response?.data?.message || "Failed to toggle API key status"));
    }
  } catch (error) {
    yield put(setError(error?.message || "Failed to toggle API key status"));
  } finally {
    yield put(setLoading(false));
  }
}

// Get API Key Usage Saga
function* getApiKeyUsageSaga(action) {
  try {
    yield put(setLoading(true));
    yield put(clearError());

    const response = yield call(getApiKeyUsage, action.payload);

    if (response?.ok) {
      if (action.payload.apiKeyId) {
        yield put(setSelectedApiKeyUsage(response.data));
      } else {
        // Handle global API key usage if needed
      }
    } else {
      yield put(setError(response?.data?.message || "Failed to fetch API key usage"));
    }
  } catch (error) {
    yield put(setError(error?.message || "Failed to fetch API key usage"));
  } finally {
    yield put(setLoading(false));
  }
}

export default function* adminApiKeysManagementSaga() {
  yield takeLatest(GetApiKeysAction.type, getApiKeysSaga);
  yield takeLatest(GetApiKeyByIdAction.type, getApiKeyByIdSaga);
  yield takeLatest(CreateApiKeyAction.type, createApiKeySaga);
  yield takeLatest(UpdateApiKeyAction.type, updateApiKeySaga);
  yield takeLatest(DeleteApiKeyAction.type, deleteApiKeySaga);
  yield takeLatest(ToggleApiKeyStatusAction.type, toggleApiKeyStatusSaga);
  yield takeLatest(GetApiKeyUsageAction.type, getApiKeyUsageSaga);
}
